export interface DevolucionInternaItem {
  id: number;
  numeroDerc?: string;
  numeroGuiaProduccion: number;
  codigoArticulo?: string;
  descripcionArticulo?: string;
  presentacion?: string;
  calibre?: string;
  pesoEmpaqueInterior: number;
  cantidadDevolucionInterna: number;
  cantidadUsada: number;
  cantidadDisponible: number;
  pesoTotal: number;
  pesoUsado: number;
  pesoDisponible: number;
}

export interface DevolucionInternaResumen {
  totalItems: number;
  pesoTotalDevolucion: number;
  pesoTotalUsado: number;
  pesoTotalDisponible: number;
}

export interface DevolucionInternaReport {
  items: DevolucionInternaItem[];
  resumen: DevolucionInternaResumen;
}

export type EstadoDevolucion = 'Disponible' | 'Parcial' | 'Consumido';

export const getEstadoDevolucion = (item: DevolucionInternaItem): EstadoDevolucion => {
  if (item.cantidadUsada <= 0) return 'Disponible';
  if (item.cantidadUsada >= item.cantidadDevolucionInterna) return 'Consumido';
  return 'Parcial';
};
